
// src/reducers/templates-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'

import { 
  FETCH_TEMPLATES,
  FETCH_TEMPLATES_REQUESTED,
  FETCH_TEMPLATES_COMPLETED,
  FETCH_TEMPLATES_FAILED,
  FETCH_TEMPLATE_LIST,
  FETCH_TEMPLATE_LIST_REQUESTED,
  FETCH_TEMPLATE_LIST_COMPLETED,
  FETCH_TEMPLATE_LIST_FAILED,
  FETCH_TEMPLATE,
  FETCH_TEMPLATE_REQUESTED,
  FETCH_TEMPLATE_COMPLETED,
  FETCH_TEMPLATE_FAILED,
  CREATE_TEMPLATE,
  CREATE_TEMPLATE_REQUESTED,
  CREATE_TEMPLATE_COMPLETED,
  CREATE_TEMPLATE_FAILED,
  UPDATE_TEMPLATE,
  UPDATE_TEMPLATE_REQUESTED,
  UPDATE_TEMPLATE_COMPLETED,
  UPDATE_TEMPLATE_FAILED,
  DELETE_TEMPLATE,
  DELETE_TEMPLATE_REQUESTED,
  DELETE_TEMPLATE_COMPLETED,
  DELETE_TEMPLATE_FAILED,
  CLEAR_TEMPLATES,
  FETCH_TEMPLATE_FIELDS_REQUESTED,
  FETCH_TEMPLATE_FIELDS_COMPLETED,
  FETCH_TEMPLATE_ALL_FIELDS_COMPLETED,
  FETCH_TEMPLATE_FIELDS_FAILED,
  INSERT_USER_PROFILE_TEMPLATE,
  IMPORT_USER_PROFILE_TEMPLATE_REQUESTED,
  IMPORT_USER_PROFILE_TEMPLATE_COMPLETED,
  IMPORT_USER_PROFILE_TEMPLATE_FAILED,
  CLEAR_USER_PROFILE_TEMPLATE,
} from '../actions/templates'
import map from 'lodash/map'
import flatten from 'lodash/flatten'
import uniq from 'lodash/uniq'
import filter from 'lodash/filter'

const initialState = {
  isFetching: false,
  isUpdating: false,
  isUpdateFailed: false,
  items: undefined,
  field_list: undefined,
}

export default function templatesReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_TEMPLATES_REQUESTED:
  case FETCH_TEMPLATE_REQUESTED:
  case DELETE_TEMPLATE_REQUESTED:
  case IMPORT_USER_PROFILE_TEMPLATE_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
    })

  case CREATE_TEMPLATE_REQUESTED:
  case UPDATE_TEMPLATE_REQUESTED:
    return Object.assign({}, state, {
      isUpdating: true,
      isUpdateFailed: false,
    })

  case FETCH_TEMPLATES_FAILED:
  case FETCH_TEMPLATE_LIST_FAILED:
  case FETCH_TEMPLATE_FAILED:
  case DELETE_TEMPLATE_FAILED:
  case IMPORT_USER_PROFILE_TEMPLATE_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case CREATE_TEMPLATE_FAILED:
  case UPDATE_TEMPLATE_FAILED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: true,
    })

  case FETCH_TEMPLATES_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: action.results,
    })

  case FETCH_TEMPLATE_LIST_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      list: undefined,
    })

  case FETCH_TEMPLATE_LIST_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      list: action.results,
    })

  case FETCH_TEMPLATE_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: mergeArray('template_id', state.items, [action.results]),
    })

  case CREATE_TEMPLATE_COMPLETED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: false,
      items: mergeArray('template_id', state.items, [action.results])
    })

  case UPDATE_TEMPLATE_COMPLETED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: false,
      items: mergeArray('template_id', state.items, [action.results])
    })

  case DELETE_TEMPLATE_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: deleteArray('template_id', state.items, action.results.template_id)
    })

  case FETCH_TEMPLATE_FIELDS_COMPLETED:
    var attach_jsons = filter(map(action.results, (template)=> template.attach_json), (json)=> json && json.fields)
    return Object.assign({}, state, {
      field_list: uniq(map(flatten(map(attach_jsons, (json)=> json.fields)), (field)=> field.name))
    })

  case FETCH_TEMPLATE_ALL_FIELDS_COMPLETED:
    let fieldList = action.results.filter(item => item.attach_json.fields.length > 0).map(item => ({
      group_id: item.group_id ? item.group_id : 0,
      fields: item.attach_json.fields.map(field => ({
        group_id: item.group_id ? item.group_id : 0,
        name: field.name,
      }))
    }))
    return Object.assign({}, state, {
      field_list: fieldList
    });

  case IMPORT_USER_PROFILE_TEMPLATE_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      userProfileTemplate : action.results[0]
    })

  case CLEAR_USER_PROFILE_TEMPLATE: 
    return Object.assign({}, state, {
      userProfileTemplate : undefined
    })

  case CLEAR_TEMPLATES:
    return initialState

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/templates-reducer.js